module.exports = __webpack_public_path__ + "static/scale-model-of-tim-kelly-lifeguard-memorial-in-torrance-california-4f94fda8b009e46710b468cda5bdfb49.png";